import { clsx as o } from "../modules/index.es.js";
import { twMerge as t } from "../modules/index.es2.js";
const c = (...r) => t(o(r));
export {
  c as cn
};
//# sourceMappingURL=styling.es.js.map
